module.exports = __webpack_public_path__ + "statics/img/logo.5cd376e7.png";